var _Path, _Path2, _Path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgWifiOutline2(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M15.582 14.56a5.39 5.39 0 00-7.163 0M18.443 11.697a9.434 9.434 0 00-12.886 0",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M20.987 8.536a13.5 13.5 0 00-17.974 0",
    stroke: "#D8D8D8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M12 19.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
    fill: "#242424"
  })));
}

export default SvgWifiOutline2;